<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <el-form ref="form" :model="dioForm" :rules="rules" label-width="160px">
            <el-form-item :label="$t('public.table_scope')" prop="sceneId" v-if="sysAdmin === 'isSysAdmin' || sysAdmin === 'isSysNoAdmin'">
                <el-select v-model="dioForm.sceneId" style="width: 250px">
                    <el-option v-for="item in scopeArrays" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('integration.base_number')" prop="plinthCode">
                <el-input v-if="!dioForm.id" v-model.trim="dioForm.plinthCode" style="width: 250px" maxlength="80" :placeholder="$t('public.please_enter')" />
                <span v-else>{{ dioForm.plinthCode }}</span>
            </el-form-item>

            <el-form-item :label="$t('integration.base_type')" prop="type">
                <el-select v-model="dioForm.type" @change="typeChange">
                    <el-option :label="$t(item.label)" :value="item.value" :key="item.id" v-for="item in sBaseType.selectParam"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('integration.nickname')" prop="nickname">
                <el-input v-model.trim="dioForm.nickname" style="width: 250px" maxlength="30" :placeholder="$t('public.please_enter')" />
            </el-form-item>

            <el-form-item :label="$t('public.table_desc')" prop="description">
                <el-input
                    v-model.trim="dioForm.description"
                    style="width: 250px;"
                    type="textarea"
                    maxlength="250"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    show-word-limit
                    :placeholder="$t('public.please_enter')"
                />
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { addBase, editBaseBaseInfo } from '@/api/modules/base.js';

// import { defaultNetParams, defaultAttrGateway02 } from '../config/default';
import { gateway02TagSize } from '@/utils/convert';
import { sBaseType } from '../config/search';

export default {
    props: ['isShow', 'title', 'scopeArray', 'editRow', 'deviceGateWayType'],
    watch: {
        scopeArray(newVal) {
            this.scopeArrays = [...newVal];
        },
        editRow(newVal) {
            const { sceneId, type, nickname, plinthCode, id, description } = newVal;
            this.dioForm = {
                sceneId: String(sceneId),
                plinthCode,
                type,
                nickname,
                id,
                description
            };
        }
    },
    computed: {
        sBaseType: () => sBaseType,
        /** 用于表示当前登录用户属于什么类型的角色 */
        sysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            if (currentUser.sysScope && currentUser.sysAdmin) {
                // 系统管理员
                return 'isSysAdmin';
            } else if (currentUser.sysScope && !currentUser.sysAdmin) {
                // 系统非管理员
                return 'isSysNoAdmin';
            } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
                // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
                return 'noSysIsAdmin';
            } else {
                // 非系统非管理员
                return 'noSysNoAdmin';
            }
        },
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val); // 可以优化成model  或者minx
            }
        },
        rules() {
            return {
                sceneId: [{ required: true, message: $t('integration.range_cannot_be_empty'), trigger: 'change' }],
                type: [{ required: true, message: $t($t('integration.the_base_type_cannot_be_empty')), trigger: 'change' }],
                nickname: [{ required: true, message: $t($t('integration.the_base_nickname_cannot_be_empty')), trigger: 'blur' }],
                plinthCode: [{ required: true, message: $t($t('integration.the_base_code_cannot_be_empty')), trigger: 'blur' }]
            };
        }
    },
    data() {
        return {
            dioForm: {
                sceneId: '',
                type: '',
                plinthCode: '',
                sn: '',
                nickname: '',
                description: ''
            },
            scopeArrays: [],
            // 是否展示网络参数 因为二代网关是没有网络参数的
            netParamShow: true,
            gateway02TagSize
        };
    },
    methods: {
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
        async justify() {
            try {
                return await this.$refs.form.validate();
            } catch (error) {
                return false;
            }
        },
        async handleSave() {
            const flag = await this.justify();
            if (!flag) return;
            let httpUrl = addBase;
            if (this.dioForm.id) {
                httpUrl = editBaseBaseInfo;
            } else {
                delete this.dioForm.id;
                for (const item of this.deviceGateWayType) {
                    if (this.dioForm.type === Number(item.value)) {
                        this.dioForm.typeCode = item.code;
                        break;
                    }
                }
            }
            this.dioForm.sceneId = this.dioForm.sceneId || this.$store.state.userInfo.scope.sceneId;
            httpUrl(this.dioForm).then(({ state }) => {
                if (state.code === 200) {
                    this.$message.success(this.dioForm.id ? this.$t('public.tip_edit_succ') : this.$t('public.tip_add_succ'));
                    this.isShowDialog = false;
                    this.$parent.getListFn();
                } else {
                    this.$message.error(state.msg);
                }
            });
        },
        typeChange(data) {
            const item = sBaseType.selectParam.find(item => item.value === data);
            this.dioForm.typeCode = item.code;
        }
    },
    mounted() {
        console.log(sBaseType);
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
    border-radius: 2px;
}
</style>
